import { Auth0Provider, AppState } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'


const AuthProviderWithNavigate = ({ children }) => {

    const navigate = useNavigate()

    const onRedirectCallback = (appState) => {
        
        const returnTo = appState?.returnTo;
        if (returnTo.startsWith('/app?code=')) {
            navigate(returnTo);
            return;
        }

        if (returnTo.startsWith('/app')) {
            navigate(returnTo.slice(4));
            return;
        }

        navigate(appState?.returnTo || window.location.pathname)
    }

    return (
        <Auth0Provider
            domain="dev-wfwqixee7y16ecqu.us.auth0.com"
            clientId="GHB9rVU86ScHrAUPtUrkbHMhJ1dOtWEY"
            authorizationParams={{ redirect_uri: window.location.origin + '/app', audience: "nvcomputers.com" }}
            onRedirectCallback={onRedirectCallback}>
            {children}
        </Auth0Provider>
    )
}

export default AuthProviderWithNavigate